// Customers with the CRM folded in (decision 169): JL, "are crm and customers page doing the same thing? i mean cant we
// consolidate". One place: Accounts (the sheet), How they're ordering (the trends from the invoices) and Follow-ups
// (tasks, birthdays, prospects). The trend is one formula everywhere: the trends' more / steady / less / gone quiet / new.
import { useAuth } from '../auth';
import { todayIso } from '../format';
import { useSearchParam } from '../hooks';
import { useLocale } from '../i18n';
import { Followups, Trends } from './CrmPage';
import { CustomersPage } from './CustomersPage';

const TABS = ['accounts', 'trends', 'followups'] as const;
type Tab = (typeof TABS)[number];

export function CustomersHome() {
  const { t } = useLocale();
  const { me } = useAuth();
  // the trends and follow-ups are for the people who sell (as the CRM was)
  const sells = me?.role === 'owner' || me?.role === 'office' || me?.role === 'sales';
  const [tabRaw, setTab] = useSearchParam('tab');
  const tab: Tab = sells && (TABS as readonly string[]).includes(tabRaw) ? (tabRaw as Tab) : 'accounts';
  const date = todayIso();
  const label: Record<Tab, string> = { accounts: t('customersTabAccounts'), trends: t('customersTabTrends'), followups: t('customersTabFollowups') };
  // a row of chips under the page's title, like the stage chips: one pressed
  const tabs = sells ? (
    <div className="chips" role="group" aria-label={t('customers')} data-testid="customer-tabs">
      {TABS.map((k) => (
        <button key={k} type="button" className="chip" aria-pressed={tab === k} onClick={() => setTab(k === 'accounts' ? '' : k)}>
          {label[k]}
        </button>
      ))}
    </div>
  ) : null;
  // no wrapper around the sheet: it sits right in the page as before, so it scrolls inside its own frame
  if (tab === 'accounts') return <CustomersPage tabs={tabs} />;
  return (
    <div className="stack">
      <h1>{t('customers')}</h1>
      {tabs}
      {tab === 'trends' ? <Trends date={date} /> : <Followups date={date} />}
    </div>
  );
}
